import React from "react"
import {useReactionUsers} from "hooks/useReactionUsers"
import {Tooltip} from "antd"
import {UserAvatar} from "../../../UserAvatar"
import styles from "./ReactionTooltip.module.css"

interface ReactionTooltipProps {
    messageId: number
    reaction: string
    count: number
    children: React.ReactNode
}

export const ReactionTooltip: React.FC<ReactionTooltipProps> = ({messageId, reaction, count, children}) => {
    const {users, isLoading, handleMouseEnter, handleMouseLeave} = useReactionUsers({
        messageId,
        reaction,
        count
    })

    const renderTooltipContent = () => {
        if (isLoading) {
            return <div className={styles.reactionTooltipLoading}>Loading...</div>
        }

        if (!users.length) {
            return <div className={styles.reactionTooltipEmpty}>No users found</div>
        }

        return (
            <div className={styles.reactionTooltipContent}>
                {users.map((user) => (
                    <div key={user.userId} className={styles.reactionTooltipUser}>
                        <UserAvatar user={user} className={styles.reactionTooltipAvatar} />
                        <span className={styles.reactionTooltipName}>{user.fullName}</span>
                    </div>
                ))}
            </div>
        )
    }

    return (
        <Tooltip
            title={renderTooltipContent()}
            placement="top"
            onVisibleChange={(visible) => {
                if (visible) {
                    handleMouseEnter()
                } else {
                    handleMouseLeave()
                }
            }}>
            {children}
        </Tooltip>
    )
}
